/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { FieldHookConfig, useField } from 'formik';
import { SelectionControlsGroupProps } from 'omakase/SelectionControls/SelectionControlsGroupCore';
import { checkFormHasError, handleChangeFormField } from '@tock/shared/ui/forms/formHelpers';
import RadioButtonGroup from 'omakase/SelectionControls/RadioButtonGroup';

/**
 * (Formik) Implementation of grouping behaviors for radio buttons.
 * Use RadioButton components as children.
 */
const FormRadiobuttonGroup: React.FunctionComponent<SelectionControlsGroupProps> = ({
  children,
  disabled,
  onChange,
  ...rest
}) => {
  const [field, meta] = useField(rest as FieldHookConfig<any>);
  const hasError = checkFormHasError(meta);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    handleChangeFormField(field, event, onChange as (evt: React.ChangeEvent<any>) => void);

  return (
    <RadioButtonGroup
      disabled={disabled}
      value={field.value}
      name={field.name}
      onChange={handleChange}
      error={hasError}
      errorText={meta.error}
      {...rest}
    >
      {React.Children.map(children, (child) => {
        return React.cloneElement(child as React.ReactElement, { disabled });
      })}
    </RadioButtonGroup>
  );
};
export default FormRadiobuttonGroup;
